import { DateTime } from 'luxon'

export const formatRelativeDate = (value: string, format: string = 'dd/MM/yyyy HH:mm') => {
  // @ts-expect-error TS2559
  const valueConverted = DateTime.fromFormat(value, format).toLocaleString('D')
  // @ts-expect-error TS2559
  const today = DateTime.now().toLocaleString('D')

  if (valueConverted === today){
    return DateTime.fromFormat(value, format).toRelative()
  } if (valueConverted !== today){
    return DateTime.fromFormat(value, format).toRelativeCalendar()
  }
}

export default formatRelativeDate
